export default {
    state: {
        locale: localStorage.getItem('locale') || 'en',
        locales: {
            en: 'EN',
            to: 'TO'
        }
    },

    getters: {
        locale: state => state.locale,
        locales: state => state.locales
    },

    mutations: {
        SET_LOCALE(state, locale) {
            state.locale = locale
        },
    },

    actions: {
        setLocale ({ commit }, { locale }) {
            commit('SET_LOCALE', locale);

            localStorage.setItem('locale', locale)
        }
    }
}